import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import metaDataReducer from './slices/uiMetaDataSlice';
import vehicleReducer from './slices/vehicle';
import filterReducer from './slices/filterSlice';
import NotificationReducer from './slices/notificationSlice';
import confirmReducer from './slices/confirmSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    metaData: metaDataReducer,
    vehicle: vehicleReducer,
    filter: filterReducer,
    notification: NotificationReducer,
    confirm: confirmReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
